import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-active-notifications-modal',
  templateUrl: './active-notifications-modal.component.html',
  styleUrls: ['./active-notifications-modal.component.scss'],
})
export class ActiveNotificationsModalComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ActiveNotificationsModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any[]) {}

  ngOnInit() {}
}
